import { Grid, Flex } from "@chakra-ui/react";
import AppSpinner from "components/spinner/AppSpinner";
import { ProjectRowData } from "../table/types";
import { ProjectCard } from "./ProjectCard";

interface ProjectsGridViewProps {
  projects: ProjectRowData[];
  isFetching: boolean;
  onViewDetails: (orderId: string) => void;
  pageLimit: number;
  tabIndex?: number;
}

export const ProjectsGridView = ({
  projects,
  isFetching,
  onViewDetails,
  pageLimit,
  tabIndex = 0,
}: ProjectsGridViewProps) => {
  if (isFetching) {
    return (
      <Flex justify="center" align="center" minH="400px">
        <AppSpinner />
      </Flex>
    );
  }

  return (
    <Grid
      templateColumns={{
        base: "1fr",
        md: "repeat(auto-fill, minmax(322px, 1fr))",
      }}
      gap="24px"
    >
      {projects.map((project) => (
        <ProjectCard
          key={project.id}
          project={project}
          onViewDetails={onViewDetails}
          tabIndex={tabIndex}
        />
      ))}
    </Grid>
  );
};
